import { Action } from "redux";
import { UnitsOfMeasurement } from "../../AltitudeRangeModifier";

export const CHANGE_UNITS_ACTION = "CHANGE_UNITS_ACTION";

export interface ChangeUnitsAction extends Action {
    units: UnitsOfMeasurement;
}

export const changeUnitsAction = (units: UnitsOfMeasurement): ChangeUnitsAction => ({
    type: CHANGE_UNITS_ACTION,
    units: units,
});
